<template>
  <PageTemplate>

    <Loader v-if="!isLoaded"/>
    <div v-else>
      <div class="d-flex justify-content-between">
        <h6 class="element-header">
          Time management
        </h6>
      </div>

      <div class="element-box">
        <h5 class="form-header mb-4">
          Monat steht die Genehmigung aus
        </h5>

        <Search
            :filters="filters"
            :loading="isSearching"
            :officeDropdown="officeDropdown"
            :userDropdown="userDropdown"
            @search="getMonthsForApproval"/>

        <PerPage :values="[10, 25, 50, 100]" @update:perPage="getMonthsForApproval"/>

        <div class="table-responsive overflow-auto pt-4">
          <table class="table table-striped">
            <thead>
            <tr>
              <th>Vorname</th>
              <th>Nachname</th>
              <th>Jahr</th>
              <th>Monat</th>
              <th></th>
              <th style=" text-align: right; padding-right: 30px; min-width: 150px;">
                {{ $t('general.actions') }}
              </th>
            </tr>
            </thead>
            <tbody>
            <tr v-for="(data) in monthsForApproval.data" :key="data.userId">
              <td>{{ data?.first_name }}</td>
              <td>{{ data?.last_name }}</td>
              <td>{{ data?.year }}</td>
              <td>{{ $t(`calendar.months_number_key.${+data?.month}`) }}</td>
              <td>
                <span style="background-color: orange; padding: 9px 14px; border-radius: 50%;">!</span>
              </td>
              <td class="text-end">
                <button class="btn btn-primary" @click="router.push({
                name: 'monthlyOverview', query: { userId: data?.userId, year: data?.year, month: data?.month  } })">
                  Übersicht
                </button>
              </td>
            </tr>
            </tbody>
          </table>
        </div>
        <Pagination
            v-if="monthsForApproval?.pagination?.total_pages > 1"
            :totalPages="monthsForApproval?.pagination?.total_pages"
            :currentPage="monthsForApproval?.pagination?.current_page"
            :totalItems="monthsForApproval?.pagination?.total_items"
            :perPage="monthsForApproval?.pagination?.items_per_page"
            @pagechanged="getMonthsForApproval"/>
      </div>
    </div>
  </PageTemplate>
</template>


<script setup>
import { timeManagementService } from '@/api/TImeManagement';
import Loader from '@/components/Loader.vue';
import PageTemplate from '@/components/PageTemplate.vue';
import Pagination from '@/components/Pagination.vue';
import PerPage from '@/components/PerPage.vue';
import { CloseToast, ErrorToast } from '@/components/VueToast';
import router from '@/router';
import { getOfficeDropdown, getUsersForHrOverviewDropdown } from '@/shared/dropdowns';
import Search from '@/views/App/TimeManagement/TMMonthsForApproval/Search.vue';
import { onMounted, ref } from 'vue';
import { useI18n } from 'vue-i18n';

const { t }             = useI18n();
const monthsForApproval = ref([]);
const filters           = ref({
  officeId: '',
  userId: '',
  orderBy: 'DESC',
  sortBy: '',
});

const isSearching    = ref(false);
const isLoaded       = ref(false);
const officeDropdown = ref([]);
const userDropdown   = ref([]);

async function getMonthsForApproval(page = 1, perPage, passedFilters) {
  if (passedFilters) {
    isSearching.value = true;
  }
  const perPageRes = monthsForApproval.value?.pagination?.items_per_page;

  try {
    const { data } = await timeManagementService.getMonthsForApproval({
      page: page,
      limit: perPage ?? perPageRes,
      ...(passedFilters ? passedFilters : filters.value),
    });

    monthsForApproval.value = data.data;
    isSearching.value       = false;
  } catch (error) {
    await ErrorToast(error);
    isSearching.value = false;
  }
}

onMounted(async () => {
  CloseToast();
  await Promise.all([
    getOfficeDropdown(officeDropdown, t),
    getUsersForHrOverviewDropdown(userDropdown),
    getMonthsForApproval(),
  ]);

  isLoaded.value = true;
});


</script>

<style scoped>

</style>